import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "13",
  viewBox: "0 0 25 13",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.18324 0.295132C1.57253 -0.0966248 2.20569 -0.0986263 2.59745 0.290662C4.37367 2.05569 7.13356 4.80627 9.44895 7.11515C10.6067 8.26968 11.6535 9.31393 12.4109 10.0695L12.9313 10.5888L23.2947 0.290661C23.6865 -0.0986263 24.3196 -0.0966247 24.7089 0.295132C25.0982 0.686889 25.0962 1.32005 24.7045 1.70934L13.6347 12.7093C13.2441 13.0975 12.6132 13.0968 12.2234 12.7078L12.9298 12C12.2234 12.7078 12.2235 12.7079 12.2234 12.7078L10.9983 11.4854C10.241 10.7299 9.19437 9.68574 8.03673 8.53135C5.72126 6.2224 2.96253 3.47297 1.18771 1.70934C0.795953 1.32005 0.793952 0.686889 1.18324 0.295132Z"
    }, null, -1)
  ]))]))
}
export default { render: render }